import { Reveal } from "@/components/Reveal";

const GROUPS = [
  {
    label: "Rebellious",
    testid: "rebellious",
    quotes: [
      "Recovery Looked Boring. We Fixed That.",
      "Heal Loud.",
      "Comeback Season.",
    ],
  },
  {
    label: "Soft Luxury",
    testid: "soft-luxury",
    quotes: [
      "Recovery, Reimagined.",
      "Built to Heal. Designed to Live In.",
      "Support That Doesn't Look Like a Setback.",
    ],
  },
  {
    label: "Punchy",
    testid: "punchy",
    quotes: [
      "Injured, Not Invisible.",
      "Still Iconic. Just Healing.",
      "Bounce Back Different.",
    ],
  },
];

export const Quotes = () => (
  <section data-testid="quotes-section" className="px-3 md:px-6 pb-4">
    <div className="bg-[#2C241E] rounded-3xl">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-36">
        <Reveal>
          <p className="text-xs font-medium tracking-[0.25em] uppercase text-[#EFE8DC]/50 mb-4">
            05 / The Voice
          </p>
          <h2
            data-testid="quotes-headline"
            className="font-display text-4xl md:text-6xl tracking-tighter text-[#EFE8DC] mb-6"
          >
            Healing, Out Loud.
          </h2>
          <p
            data-testid="quotes-subtext"
            className="text-sm md:text-base leading-relaxed text-[#EFE8DC]/60 max-w-xl mb-16"
          >
            Every LIGATEN brace can be printed with your words — choose any of these quotes and
            it's stitched across your band.
          </p>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10">
          {GROUPS.map((group, gi) => (
            <div key={group.testid} data-testid={`quote-group-${group.testid}`}>
              <Reveal delay={gi * 0.1}>
                <p className="text-xs font-medium tracking-[0.25em] uppercase text-[#B8AFA6] mb-6">
                  {group.label}
                </p>
              </Reveal>
              <div>
                {group.quotes.map((quote, qi) => (
                  <Reveal key={quote} delay={gi * 0.1 + qi * 0.08}>
                    <p
                      data-testid={`quote-${group.testid}-${qi + 1}`}
                      className="font-display text-2xl md:text-[1.7rem] leading-snug text-[#EFE8DC] border-t border-[#EFE8DC]/15 py-5"
                    >
                      {quote}
                    </p>
                  </Reveal>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
